import { mdlPremiumMainCoversCompRenewal } from "./mdlPremiumMainCoversCompRenewal";
import { mdlPremiumAdditionalCoversCompRenewal } from "./mdlPremiumAdditionalCoversCompRenewal";


export class mdlPreminumDetailsCompRenewal {
    public CoverDetails: Array<mdlPremiumMainCoversCompRenewal> = new Array<mdlPremiumMainCoversCompRenewal>();

    public AdditionalCovers: Array<mdlPremiumAdditionalCoversCompRenewal> = new Array<mdlPremiumAdditionalCoversCompRenewal>();

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPreminumDetailsCompRenewal.ts